
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">分享助力简介</div>
      <div class="panel-body">
        <p class="p1">功能简介:</p>
        <p
          class="span1"
        >分享助力又名微信助力活动，常被称为微助力活动，参与分享助力活动的微信粉丝必须通过好友的帮助才可以获得助力值，并通助力值的高低来进行排名排行，商家可以通过对排行榜来进行相关奖品赠送发放。微信分享助力是商家用来引爆微信好友圈的一种裂变式功能活动，以便达到更大的营销宣传效果。当活动中出现相同助力值时，最终排名以转发求助数多者为排名优先，参与者可以给自己助力1个值，但一个好友最多只能助力1个值，故助力值越高者表示转发好友帮助效果更好。微信分享助力含有两种助力页面模板，版本一允许自定义助力头部横幅图片，助力活动背景图片，允许自定义转发二维码背景图片，还允许上传活动开始按钮图片。活动相关情况比如奖品以及参与规则等可以直接添加到活动规则中，允许添加图文介绍。而版本二则采用固定页面模板，直接可以添加轮播图以及奖项介绍等，相对版本一更简单省事。不管何种页面模板，分享助力还允许设置需要关注后参与活动，以及需要好友关注后才能发起帮助。</p>
        <p class="p1">适用账号:</p>
        <p class="span1">服务号、订阅号、认证服务号、认证订阅号</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


